import { useState, useEffect } from 'react';
import { Play, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { useScanConfig, useUpdateScanConfig, useTriggerScan } from '@/hooks/useUplog';

export function ScannerConfig() {
  const { data: config, isLoading } = useScanConfig();
  const { mutate: update, isPending: saving } = useUpdateScanConfig();
  const { mutate: trigger, isPending: scanning } = useTriggerScan();

  const [scanHour, setScanHour] = useState('07:00');
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (config) {
      setScanHour(config.scanHour ?? '07:00');
      setActive(config.isActive);
    }
  }, [config]);

  function handleSave() {
    update({ scanHour, isActive: active });
  }

  function handleToggle(val: boolean) {
    setActive(val);
    update({ isActive: val });
  }

  if (isLoading) return null;

  const lastScan = config?.lastScanAt
    ? new Date(config.lastScanAt).toLocaleString('pt-BR')
    : 'Nunca';

  return (
    <Card>
      <CardHeader>
        <CardTitle>Robô Scanner</CardTitle>
        <CardDescription>
          Verifica pendências automaticamente no horário configurado (fuso: América/São Paulo).
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="scanner-active">Ativar scanner automático</Label>
          <Switch
            id="scanner-active"
            checked={active}
            onCheckedChange={handleToggle}
            disabled={saving}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="scan-hour">Horário do scan</Label>
          <Input
            id="scan-hour"
            type="time"
            value={scanHour}
            onChange={(e) => setScanHour(e.target.value)}
            className="w-32"
          />
          <p className="text-xs text-muted-foreground">
            O scan será executado uma vez por dia neste horário.
          </p>
        </div>

        <p className="text-xs text-muted-foreground">
          Último scan: <span className="font-medium">{lastScan}</span>
        </p>

        <div className="flex gap-2 pt-1">
          <Button onClick={handleSave} disabled={saving}>
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Salvar
          </Button>
          <Button variant="outline" onClick={() => trigger()} disabled={scanning}>
            {scanning ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Play className="mr-2 h-4 w-4" />
            )}
            Escanear agora
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
